import { createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-63c09f6d")

_pushScopeId("data-v-63c09f6d")
const _hoisted_1 = { class: "input__datetime__date" }
const _hoisted_2 = { class: "label-wrapped" }
const _hoisted_3 = /*#__PURE__*/_createVNode("label", { for: "purpose-date -bold" }, "희망 진료일", -1)
const _hoisted_4 = {
  key: 0,
  class: "selected-date"
}
const _hoisted_5 = { class: "input__datetime__time label-wrapped" }
const _hoisted_6 = /*#__PURE__*/_createVNode("label", {
  for: "purpose-time",
  class: "-bold"
}, "희망 진료 시간 ", -1)
const _hoisted_7 = /*#__PURE__*/_createVNode("span", { class: "input__datetime--desc" }, [
  /*#__PURE__*/_createVNode("small", null, [
    /*#__PURE__*/_createVNode("b", null, "한국표준시(KST, UTC/GMT+09:00)"),
    /*#__PURE__*/_createTextVNode(" 기준")
  ]),
  /*#__PURE__*/_createVNode("small", null, "희망일자 및 희망시간은 의사 선택 후 선택 및 수정가능")
], -1)
const _hoisted_8 = {
  key: 1,
  class: "input__datetime--scheduled-datetime -readonly"
}
const _hoisted_9 = /*#__PURE__*/_createVNode("label", null, "예약일자", -1)
const _hoisted_10 = { style: {"min-width":"80px"} }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Calendar = _resolveComponent("Calendar")
  const _component_Dropdown = _resolveComponent("Dropdown")

  return (_openBlock(), _createBlock("div", {
    class: ["input__datetime", _ctx.isLine ? 'isLine' : 'notIsLine']
  }, [
    (_ctx.state.isEditable)
      ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
          _createVNode("div", _hoisted_1, [
            _createVNode("div", _hoisted_2, [
              _hoisted_3,
              (_ctx.isLine)
                ? (_openBlock(), _createBlock("span", _hoisted_4, _toDisplayString(_ctx.selectDate), 1))
                : _createCommentVNode("", true)
            ]),
            _createVNode(_component_Calendar, {
              modelValue: _ctx.state.purpose.date,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.state.purpose.date = $event)),
              dateFormat: "yy-mm-dd",
              disabledDays: _ctx.state.disabledDays,
              disabled: !_ctx.state.purpose.doctorKey || _ctx.state.disabled,
              minDate: _ctx.date.minDate,
              maxDate: _ctx.date.maxDate,
              manualInput: false,
              disabledDates: _ctx.state.invalidDates,
              inline: _ctx.state.isLine,
              touchUI: !_ctx.state.isLine,
              id: "purpose-date"
            }, null, 8, ["modelValue", "disabledDays", "disabled", "minDate", "maxDate", "disabledDates", "inline", "touchUI"])
          ]),
          _createVNode("div", _hoisted_5, [
            _hoisted_6,
            (_ctx.state.isEditable)
              ? (_openBlock(), _createBlock(_component_Dropdown, {
                  key: 0,
                  modelValue: _ctx.state.purpose.time,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.state.purpose.time = $event)),
                  options: _ctx.state.enableTimeList,
                  disabled: !_ctx.state.purpose.date || _ctx.state.disabled,
                  id: "purpose-time"
                }, null, 8, ["modelValue", "options", "disabled"]))
              : _createCommentVNode("", true)
          ]),
          _hoisted_7
        ], 64))
      : (_openBlock(), _createBlock("section", _hoisted_8, [
          _hoisted_9,
          _createVNode("div", _hoisted_10, _toDisplayString(_ctx.state.purpose.date ?? "") + " " + _toDisplayString(_ctx.state.purpose.time ?? ""), 1)
        ]))
  ], 2))
})